/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Test_No_DevicesInputs */

const th_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีอุปกรณ์ที่ลงทะเบียนรับการแจ้งเตือน จึงไม่มีปลายทางให้ส่ง`)
};

const en_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No devices are registered to receive push, so there was nothing to send to.`)
};

const ja_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュを受け取る端末が登録されていないため、送信先がありませんでした。`)
};

const zh_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有设备注册推送，因此无处可发。`)
};

const es_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay dispositivos registrados para recibir notificaciones, así que no había a dónde enviarla.`)
};

const pt_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dispositivo está registrado para receber push, então não havia para onde enviar.`)
};

const id_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada perangkat yang terdaftar untuk push, jadi tidak ada tujuan pengiriman.`)
};

const fr_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun appareil n’est enregistré pour recevoir des push, il n’y avait donc nulle part où envoyer.`)
};

const tl_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang device na nakarehistro para sa push, kaya walang mapagpapadalhan.`)
};

const vi_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thiết bị nào đăng ký nhận đẩy, nên không có chỗ để gửi.`)
};

const ko_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시에 등록된 기기가 없어 보낼 곳이 없었습니다.`)
};

const de_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist kein Gerät für Push registriert, es gab also nichts, wohin gesendet werden konnte.`)
};

const ru_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни одно устройство не зарегистрировано для push, поэтому отправлять было некуда.`)
};

const tr_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlık bildirim için kayıtlı cihaz yok, bu yüzden gönderilecek yer yoktu.`)
};

const it_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dispositivo registrato per le notifiche push, quindi non c'era dove inviare.`)
};

const pl_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żadne urządzenie nie jest zarejestrowane do powiadomień push, więc nie było dokąd wysłać.`)
};

const uk_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жодного пристрою не зареєстровано для push, тож надсилати не було куди.`)
};

const hi_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुश के लिए कोई उपकरण दर्ज नहीं है, इसलिए भेजने की कोई जगह नहीं थी।`)
};

const ar_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد جهاز مسجَّل للإشعارات الفورية، فلم يكن هناك وجهة للإرسال.`)
};

const ms_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada peranti didaftarkan untuk tolakan, jadi tiada tempat untuk menghantar.`)
};

const bn_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পুশের জন্য কোনও যন্ত্র নিবন্ধিত নয়, তাই পাঠানোর জায়গা ছিল না।`)
};

const zh_tw2_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有裝置註冊推播，因此無處可送。`)
};

const zh_hk2_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有裝置註冊推播，因此無處可送。`)
};

const ur_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پُش کے لیے کوئی آلہ درج نہیں، اس لیے بھیجنے کی کوئی جگہ نہیں تھی۔`)
};

const fa_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دستگاهی برای اعلان فوری ثبت نشده، پس جایی برای فرستادن نبود.`)
};

const sw_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna kifaa kilichosajiliwa kupokea arifa, kwa hivyo hakukuwa na pa kutuma.`)
};

const nl_test_no_devices = /** @type {(inputs: Test_No_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is geen apparaat geregistreerd voor push, dus er was nergens heen te sturen.`)
};

/**
* | output |
* | --- |
* | "No devices are registered to receive push, so there was nothing to send to." |
*
* @param {Test_No_DevicesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_no_devices = /** @type {((inputs?: Test_No_DevicesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_No_DevicesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_no_devices(inputs)
	if (locale === "ja") return ja_test_no_devices(inputs)
	if (locale === "zh") return zh_test_no_devices(inputs)
	if (locale === "es") return es_test_no_devices(inputs)
	if (locale === "pt") return pt_test_no_devices(inputs)
	if (locale === "id") return id_test_no_devices(inputs)
	if (locale === "fr") return fr_test_no_devices(inputs)
	if (locale === "tl") return tl_test_no_devices(inputs)
	if (locale === "vi") return vi_test_no_devices(inputs)
	if (locale === "ko") return ko_test_no_devices(inputs)
	if (locale === "de") return de_test_no_devices(inputs)
	if (locale === "ru") return ru_test_no_devices(inputs)
	if (locale === "tr") return tr_test_no_devices(inputs)
	if (locale === "it") return it_test_no_devices(inputs)
	if (locale === "pl") return pl_test_no_devices(inputs)
	if (locale === "uk") return uk_test_no_devices(inputs)
	if (locale === "hi") return hi_test_no_devices(inputs)
	if (locale === "ar") return ar_test_no_devices(inputs)
	if (locale === "ms") return ms_test_no_devices(inputs)
	if (locale === "bn") return bn_test_no_devices(inputs)
	if (locale === "zh-TW") return zh_tw2_test_no_devices(inputs)
	if (locale === "zh-HK") return zh_hk2_test_no_devices(inputs)
	if (locale === "ur") return ur_test_no_devices(inputs)
	if (locale === "fa") return fa_test_no_devices(inputs)
	if (locale === "sw") return sw_test_no_devices(inputs)
	if (locale === "nl") return nl_test_no_devices(inputs)
	return en_test_no_devices(inputs)
});